// @flow
import React from "react";

export type HeatMapType = { value: number, maxValue: number, color: string };

export default function heatMap({ value, maxValue, color }: HeatMapType) {
  let percentileOfMax = 0;
  if (maxValue != 0) percentileOfMax = (100 / maxValue) * value;
  const opacity = percentileOfMax / 100 || 0;
  return (
    <div
      className={`w-100 h-100 d-flex justify-content-center align-items-center `}
      style={{
        backgroundColor: `rgba(${color[0]},${color[1]},${color[2]},${opacity})`,
      }}
    >
      <div>{value.toString()}</div>
    </div>
  );
}
